export const heroData = {
  tag: "每日更新 · 高清流畅",
  h1: "91视频网站 — 海量高清视频免费在线观看平台",
  slogan: "电影、电视剧、综艺、动漫，你想看的这里都有",
  intro: "91视频网站汇集全网热门影视资源，涵盖院线大片、热播电视剧、人气综艺、经典动漫等丰富内容。平台每日同步更新最新剧集，支持多线路切换确保流畅播放体验。无论是追最新番剧还是重温经典老片，91视频都能为你提供一站式免费在线观看服务，无需下载、无需注册，打开即看。",
  stats: [
    { label: "日均更新", value: "200+" },
    { label: "影视资源", value: "50,000+" },
    { label: "高清画质", value: "1080P" },
  ],
  primaryCta: { text: "开始观看", href: "#index" },
  secondaryCta: { text: "了解平台", href: "#about" },
};

export const carouselData = [
  {
    id: 1,
    title: "暑期档热门电影专题",
    description: "盘点今夏最值得期待的院线大片，动作、喜剧、科幻一网打尽，91视频为你实时追踪最新影视动态",
    image: "https://readdy.ai/api/search-image?query=cinematic%20summer%20movie%20poster%20collage%20with%20warm%20golden%20lighting%2C%20film%20reel%20texture%2C%20dramatic%20composition%2C%20dark%20theater%20background%20with%20soft%20spotlight%2C%20luxurious%20cinema%20aesthetic&width=800&height=450&seq=carousel-01&orientation=landscape",
    tag: "热门推荐",
  },
  {
    id: 2,
    title: "高分悬疑剧集盘点",
    description: "从国产佳作到海外神剧，91视频精选多部口碑悬疑剧，紧张刺激的剧情让你一次看过瘾",
    image: "https://readdy.ai/api/search-image?query=mystery%20thriller%20cinematic%20scene%20with%20dramatic%20shadow%20and%20light%20contrast%2C%20film%20noir%20style%2C%20dark%20moody%20atmosphere%2C%20suspenseful%20composition%20with%20warm%20accent%20lighting&width=800&height=450&seq=carousel-02&orientation=landscape",
    tag: "悬疑精选",
  },
  {
    id: 3,
    title: "经典港片回忆录",
    description: "回到港片黄金年代，91视频为你整理那些年陪伴我们成长的经典香港电影，满满都是青春记忆",
    image: "https://readdy.ai/api/search-image?query=nostalgic%20hong%20kong%20cinema%20aesthetic%20with%20neon%20signs%20and%20vintage%20film%20texture%2C%20warm%20retro%20color%20palette%2C%20classic%20movie%20atmosphere%2C%20cinematic%20composition&width=800&height=450&seq=carousel-03&orientation=landscape",
    tag: "经典回顾",
  },
  {
    id: 4,
    title: "国漫崛起作品巡礼",
    description: "从大圣归来到哪吒，91视频盘点近年国产动画电影的突破之作，见证国漫的华丽蜕变",
    image: "https://readdy.ai/api/search-image?query=chinese%20animation%20art%20style%20with%20vibrant%20colors%20and%20ink%20wash%20painting%20influence%2C%20fantasy%20landscape%20with%20floating%20mountains%2C%20ethereal%20lighting%2C%20cinematic%20widescreen%20composition&width=800&height=450&seq=carousel-04&orientation=landscape",
    tag: "国漫专题",
  },
  {
    id: 5,
    title: "热播综艺追更指南",
    description: "音乐竞演、真人秀、脱口秀，91视频为你整理当下最火综艺节目的追更日历和精彩看点",
    image: "https://readdy.ai/api/search-image?query=entertainment%20variety%20show%20stage%20with%20colorful%20lighting%20and%20dynamic%20composition%2C%20concert%20atmosphere%2C%20warm%20spotlights%2C%20energetic%20performance%20scene%20with%20vibrant%20color%20palette&width=800&height=450&seq=carousel-05&orientation=landscape",
    tag: "综艺热追",
  },
  {
    id: 6,
    title: "小众文艺片发现计划",
    description: "91视频精选多部被埋没的小众佳作，从独立电影到艺术短片，让你发现不一样的影像之美",
    image: "https://readdy.ai/api/search-image?query=arthouse%20cinema%20aesthetic%20with%20soft%20natural%20lighting%2C%20film%20projector%20beam%20in%20dark%20room%2C%20minimalist%20composition%2C%20warm%20amber%20tones%2C%20contemplative%20atmosphere&width=800&height=450&seq=carousel-06&orientation=landscape",
    tag: "发现好片",
  },
];

export const faqData = [
  {
    id: 1,
    question: "91视频网站是否需要注册才能观看？",
    answer: "不需要。91视频网站坚持免费开放原则，所有视频内容均可直接在线观看，无需注册账号、无需登录，打开网站即可畅享海量影视资源。我们致力于为用户提供最便捷的观影体验。",
  },
  {
    id: 2,
    question: "91在线视频的播放画质如何？",
    answer: "平台提供最高1080P高清画质，支持根据网络状况自动切换清晰度。大部分热门影片和剧集均提供超清片源，确保您获得流畅细腻的观看体验。同时支持多播放线路切换，遇到卡顿可一键换线。",
  },
  {
    id: 3,
    question: "91视频的内容更新频率是怎样的？",
    answer: "91视频网站保持每日更新节奏，热播电视剧和综艺节目在播出后最快2小时内上线，电影资源在院线下映后第一时间同步。您可以关注网站「最新动态」模块了解每日上新的具体内容。",
  },
  {
    id: 4,
    question: "91免费在线视频支持哪些设备观看？",
    answer: "91视频网站全面适配PC端、平板电脑和手机浏览器，无需下载任何软件即可在各种设备上流畅观看。同时我们提供移动端专属入口，在手机上也能获得优化的浏览和播放体验。",
  },
  {
    id: 5,
    question: "遇到播放问题怎么办？",
    answer: "如果您在观看91视频过程中遇到卡顿、无法播放等问题，请首先尝试切换播放线路（播放器内通常提供2-3条备选线路）。如依旧无法解决，可通过「联系我们」模块反馈具体影片名称和问题描述。",
  },
  {
    id: 6,
    question: "91视频网站的内容来源是否合规？",
    answer: "91视频网站严格遵循相关法律法规，所有展示的影视内容均来自合法合规的公开资源渠道。我们重视知识产权保护，如涉及版权问题欢迎权利人通过联系方式与我们沟通处理。",
  },
];

export const aboutData = {
  title: "关于91视频网站",
  content: "91视频网站成立于2020年，是国内领先的免费在线视频聚合平台。平台以「让每个人都能轻松享受优质影视内容」为使命，通过智能推荐算法和多源内容聚合技术，为用户提供覆盖电影、电视剧、综艺、动漫、纪录片等全品类的高清视频内容。\n\n经过多年运营，91视频已累计服务超过千万用户，日均活跃用户突破百万。平台持续优化播放体验和内容更新速度，致力于成为中文互联网最值得信赖的免费视频观看平台。无论您偏爱何种类型，在91视频网站都能找到心仪的好内容。",
};

export const contactData = {
  title: "联系我们",
  description: "如果您有任何关于91视频网站的建议、投稿意向或合作需求，欢迎通过以下方式与我们取得联系。我们珍视每一位用户的反馈。",
  email: "feedback@91video-site.com",
  wechat: "91video_official",
  qq: "4001234567",
};

export const rankingData = [
  { rank: 1, title: "狂飙", type: "电视剧", hot: "9.8", desc: "年度现象级反黑刑侦剧，张译张颂文飙戏封神" },
  { rank: 2, title: "流浪地球2", type: "电影", hot: "9.6", desc: "国产科幻里程碑续作，视觉与情感双重震撼" },
  { rank: 3, title: "奔跑吧·生态篇", type: "综艺", hot: "9.5", desc: "全新一季户外真人秀，笑点密集全程高能" },
  { rank: 4, title: "斗罗大陆", type: "动漫", hot: "9.4", desc: "国漫年番天花板，唐三冒险之旅持续高燃" },
  { rank: 5, title: "三体", type: "电视剧", hot: "9.3", desc: "刘慈欣科幻巨著改编，硬核科幻国产剧新标杆" },
  { rank: 6, title: "满江红", type: "电影", hot: "9.2", desc: "张艺谋执导古装悬疑，沈腾易烊千玺同台飙戏" },
];

export const mediaData = [
  {
    id: 1,
    title: "暑期档电影混剪精选",
    duration: "05:32",
    views: "128.6万",
    image: "https://readdy.ai/api/search-image?query=cinematic%20movie%20montage%20aesthetic%20with%20film%20strip%20borders%2C%20warm%20golden%20and%20amber%20lighting%2C%20dramatic%20composition%2C%20theater%20curtain%20texture%2C%20luxurious%20cinema%20feel&width=640&height=360&seq=media-01&orientation=landscape",
  },
  {
    id: 2,
    title: "悬疑剧高能片段合集",
    duration: "08:15",
    views: "96.3万",
    image: "https://readdy.ai/api/search-image?query=suspenseful%20thriller%20scene%20with%20dark%20moody%20lighting%2C%20dramatic%20shadows%2C%20film%20noir%20aesthetic%2C%20rainy%20night%20atmosphere%2C%20cinematic%20wide%20shot&width=640&height=360&seq=media-02&orientation=landscape",
  },
  {
    id: 3,
    title: "国漫名场面TOP20",
    duration: "12:40",
    views: "215.8万",
    image: "https://readdy.ai/api/search-image?query=chinese%20animation%20epic%20battle%20scene%20with%20vibrant%20energy%20effects%2C%20dynamic%20composition%2C%20ink%20wash%20style%20elements%2C%20dramatic%20lighting%20with%20warm%20golden%20accents&width=640&height=360&seq=media-03&orientation=landscape",
  },
  {
    id: 4,
    title: "经典港片武打集锦",
    duration: "06:48",
    views: "87.2万",
    image: "https://readdy.ai/api/search-image?query=kung%20fu%20action%20scene%20with%20dynamic%20movement%2C%20warm%20retro%20color%20grading%2C%20hong%20kong%20cinema%20aesthetic%2C%20dramatic%20lighting%2C%20martial%20arts%20composition&width=640&height=360&seq=media-04&orientation=landscape",
  },
];

export const indexData = [
  { id: 1, title: "动作大片", icon: "ri-fire-line", count: "1,286部", desc: "热血刺激的动作电影合集" },
  { id: 2, title: "喜剧专场", icon: "ri-emotion-laugh-line", count: "952部", desc: "让你开怀大笑的欢乐时光" },
  { id: 3, title: "悬疑推理", icon: "ri-search-eye-line", count: "673部", desc: "烧脑悬疑剧集一网打尽" },
  { id: 4, title: "科幻奇幻", icon: "ri-rocket-line", count: "518部", desc: "探索未来与异世界的视觉盛宴" },
  { id: 5, title: "爱情剧情", icon: "ri-heart-line", count: "1,104部", desc: "触动心弦的浪漫故事" },
  { id: 6, title: "动漫番剧", icon: "ri-ghost-line", count: "2,340部", desc: "日漫国漫热门新番应有尽有" },
  { id: 7, title: "纪录纪实", icon: "ri-camera-line", count: "487部", desc: "真实世界的精彩纪录" },
  { id: 8, title: "综艺娱乐", icon: "ri-mic-line", count: "826部", desc: "热门综艺一站式追更" },
];

export const updatesData = [
  { id: 1, date: "07-30", title: "《庆余年2》全集上线", type: "上新" },
  { id: 2, date: "07-29", title: "《封神第一部》高清版登陆", type: "上新" },
  { id: 3, date: "07-28", title: "《歌手2026》最新期已更新", type: "更新" },
  { id: 4, date: "07-27", title: "《你的名字。》重映版上线", type: "上新" },
  { id: 5, date: "07-26", title: "平台播放线路优化升级完成", type: "公告" },
  { id: 6, date: "07-25", title: "《唐诡之西行》超前点播开启", type: "上新" },
  { id: 7, date: "07-24", title: "暑期档片单专题页面上线", type: "专题" },
  { id: 8, date: "07-23", title: "移动端加载速度提升30%", type: "公告" },
];

export const commentsData = [
  {
    id: 1,
    name: "光影追梦人",
    avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20asian%20person%2C%20warm%20studio%20lighting%2C%20natural%20expression%2C%20clean%20background%2C%20headshot%20style&width=80&height=80&seq=avatar-01&orientation=squarish",
    date: "2026-07-28",
    content: "91视频网站真的太好用了！片源更新速度比我想象的快多了，清晰度也很棒。平时追剧基本都在这上面，省了好多找资源的时间。推荐给身边好多朋友了！",
    likes: 326,
  },
  {
    id: 2,
    name: "追剧小达人",
    avatar: "https://readdy.ai/api/search-image?query=casual%20portrait%20photo%20of%20young%20person%2C%20warm%20natural%20lighting%2C%20friendly%20expression%2C%20simple%20background%2C%20headshot%20photography&width=80&height=80&seq=avatar-02&orientation=squarish",
    date: "2026-07-26",
    content: "国漫专区做得很用心，分类清晰找片方便。最满意的是多线路切换功能，网络不好的时候一键就能换，基本没遇到过完全看不了的情况。91视频免费在线观看体验真的不错！",
    likes: 198,
  },
  {
    id: 3,
    name: "银幕漫步者",
    avatar: "https://readdy.ai/api/search-image?query=warm%20portrait%20photo%20of%20person%20with%20glasses%2C%20soft%20studio%20lighting%2C%20thoughtful%20expression%2C%20clean%20minimal%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish",
    date: "2026-07-25",
    content: "作为一名老影迷，91视频的资源丰富度让我惊喜。从小众文艺片到经典老片都能找到，更新也很及时。希望平台越做越好，会一直支持的！",
    likes: 452,
  },
];

export const appData = {
  title: "随时随地 · 畅享91视频",
  description: "91视频网站移动端适配完善，在手机浏览器中打开即可获得原生应用般的流畅体验。支持手势控制、画中画播放、夜间模式等贴心功能，让你在地铁上、午休时随时追剧看电影。无需下载安装，省内存更省心。",
  features: ["免下载即开即看", "手势控制亮度音量", "画中画悬浮播放", "夜间模式护眼舒适"],
};

export const cardsData = [
  {
    id: 1,
    title: "今夏最燃动作片盘点",
    desc: "91视频精选暑期档动作大片，从好莱坞特效巨制到国产硬核武打，热血场面一网打尽",
    image: "https://readdy.ai/api/search-image?query=action%20movie%20explosion%20scene%20with%20warm%20orange%20fire%20lighting%2C%20dramatic%20cinematic%20composition%2C%20hero%20silhouette%2C%20epic%20scale%2C%20filmic%20color%20grading&width=600&height=400&seq=cards-01&orientation=landscape",
    tag: "观影指南",
  },
  {
    id: 2,
    title: "高分国产剧推荐清单",
    desc: "从古装权谋到现代职场，91在线视频为你整理近两年豆瓣8分以上的国产好剧",
    image: "https://readdy.ai/api/search-image?query=chinese%20period%20drama%20aesthetic%20with%20warm%20lantern%20lighting%2C%20traditional%20architecture%2C%20cinematic%20composition%2C%20soft%20golden%20hour%20light%2C%20elegant%20atmosphere&width=600&height=400&seq=cards-02&orientation=landscape",
    tag: "剧集推荐",
  },
  {
    id: 3,
    title: "周末治愈系电影清单",
    desc: "忙碌一周后，91视频为你挑选温暖治愈的影片，让身心在光影中获得放松与慰藉",
    image: "https://readdy.ai/api/search-image?query=cozy%20warm%20living%20room%20with%20soft%20sunlight%20through%20window%2C%20comfortable%20atmosphere%2C%20cinematic%20lighting%2C%20relaxing%20weekend%20vibe%2C%20gentle%20warm%20tones&width=600&height=400&seq=cards-03&orientation=landscape",
    tag: "周末片单",
  },
  {
    id: 4,
    title: "科幻迷必看硬核大片",
    desc: "从太空探索到AI觉醒，91视频汇集最具想象力的科幻电影，带你探索未知世界",
    image: "https://readdy.ai/api/search-image?query=futuristic%20sci-fi%20cityscape%20with%20neon%20accents%2C%20cinematic%20wide%20shot%2C%20warm%20and%20cool%20light%20contrast%2C%20atmospheric%20fog%2C%20epic%20scale%20composition&width=600&height=400&seq=cards-04&orientation=landscape",
    tag: "科幻专题",
  },
  {
    id: 5,
    title: "2026年必追动漫新番",
    desc: "91视频动漫频道为你整理本年度值得期待的动画新作，日漫国漫一应俱全",
    image: "https://readdy.ai/api/search-image?query=anime%20art%20style%20landscape%20with%20vibrant%20colors%20and%20dreamy%20atmosphere%2C%20cherry%20blossom%20petals%2C%20warm%20sunset%20lighting%2C%20fantasy%20composition%2C%20cinematic%20feel&width=600&height=400&seq=cards-05&orientation=landscape",
    tag: "动漫指南",
  },
  {
    id: 6,
    title: "真人秀综艺追更日历",
    desc: "91视频整理各大平台热门综艺播出时间表，音乐竞演、推理探案、旅行慢综一表掌握",
    image: "https://readdy.ai/api/search-image?query=variety%20show%20stage%20with%20dynamic%20colorful%20lighting%2C%20concert%20atmosphere%2C%20energetic%20crowd%2C%20warm%20spotlight%20beams%2C%20entertainment%20production%20aesthetic&width=600&height=400&seq=cards-06&orientation=landscape",
    tag: "综艺日历",
  },
];

export const topicsData = [
  { id: 1, name: "暑期档", count: "3,286" },
  { id: 2, name: "国漫崛起", count: "2,851" },
  { id: 3, name: "悬疑剧", count: "2,640" },
  { id: 4, name: "高分电影", count: "4,512" },
  { id: 5, name: "热播剧", count: "5,873" },
  { id: 6, name: "港片经典", count: "1,967" },
  { id: 7, name: "科幻大片", count: "2,134" },
  { id: 8, name: "动画电影", count: "3,098" },
  { id: 9, name: "综艺追更", count: "1,745" },
  { id: 10, name: "文艺片", count: "1,432" },
];

export const featuresData = [
  {
    id: 1,
    icon: "ri-speed-up-line",
    title: "极速播放体验",
    desc: "91视频采用多CDN加速和多线路切换技术，确保在任何网络环境下都能流畅观看高清视频，告别卡顿和缓冲等待。",
  },
  {
    id: 2,
    icon: "ri-stack-line",
    title: "海量内容库",
    desc: "91在线视频持续收录全网优质影视资源，覆盖电影、电视剧、综艺、动漫等多品类，每日更新确保内容新鲜度。",
  },
  {
    id: 3,
    icon: "ri-device-line",
    title: "全设备适配",
    desc: "91免费在线视频完美兼容PC、平板、手机等各种设备，无需安装APP，打开浏览器即可获得一致的优质观看体验。",
  },
];

export const navItems = [
  { label: "主题索引", href: "#index" },
  { label: "平台特色", href: "#features" },
  { label: "精彩视频", href: "#media" },
  { label: "最新动态", href: "#updates" },
  { label: "用户评价", href: "#comments" },
  { label: "精选专题", href: "#carousel" },
];